"use strict";

angular
    .module('rmStationSettings', []);

require('./controllers');
require('./directives');
require('./resources');
require('./services');
require('./routes');
